<div class="p8-bdc_page__container">
  <p8-bdc-breadcrumb [(opened)]="opened"
                     [page]="currentTree"
                     (window:resize)="toggleSidenav($event)"
  ></p8-bdc-breadcrumb>
  <mat-drawer-container style="top: 100px">
    <mat-drawer [mode]="sidenavMode" [opened]="opened" style="width: 300px;">
      <div class="content am-page" *ngIf="currentTree">
        <app-tree [parents]="getPages(currentTree?.children)" [editMode]="false"
                  (onClick)="onClick($event)"></app-tree>
      </div>
    </mat-drawer>
    <mat-drawer-content>
      <!--<pre>{{currentTree|json}}</pre>-->
      <div class="p8-bdc_page__content-container mat-typography" *ngIf="page">
        <div class="p8-bdc_page__columns-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="48px">
          <div class="p8-bdc_page__article-container p8-justify" fxFlex>
            <div class="p8-bdc_page__title-container" fxLayout="row">
              <div fxFlex>
                <div>
                  <p8-bdc-search-pages fxHide.gt-xs fxFlex.xs="calc(60% - 5px)" fxLayoutAlign="end" appearance="outline" floatLabel="never"></p8-bdc-search-pages>
                </div>
                <div class="mat-headline">{{ page.title }}</div>
                <div class="mat-caption p8-secondary">Dernière modification le {{ page.dt_updated | date:'dd/MM/yyyy' }}</div>
              </div>
              <button mat-icon-button *ngIf="can_edit" (click)="openPage(page)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
            <mat-divider></mat-divider>
            <p8-bdc-page-content [content]="page.content.body"></p8-bdc-page-content>
            <p8-bdc-comment *ngIf="loggedIn()" [page]="page"></p8-bdc-comment>
          </div>
          <div class="p8-bdc_page__sidebar-container">
            <div class="mat-title p8-normal" *ngIf="page.documents_obj?.length > 0">Documents</div>
            <p8-bdc-document *ngIf="page.documents_obj && page.documents_obj.length > 0" [documents]="page.documents_obj"></p8-bdc-document>
          </div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
